import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { User } from '../shared/models/user';
import { auth } from 'firebase/app';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from './data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import axios from 'axios';
import { AngularFireStorage } from '@angular/fire/storage';
import { map, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userData: any; // Save logged in user data
  private _authState$: Observable<boolean>;
  loading = false;

  error = '';
  
  private rapidKey = 'bc11b2d1a4mshaaef35331e8271ap13cf22jsna02a131a79a6';

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
    private dataService: DataService,
    public ngZone: NgZone,// NgZone service to remove outside scope warning
  ) { 
    this._authState$ = this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          // User is authenticated
          return this.afAuth.idTokenResult;
        } else {
          // User is not authenticated
          return new BehaviorSubject(null);
        }
      }),
      map((idTokenResult) => !!idTokenResult),
      shareReplay(1)
    );
   }

  get authState$(): Observable<boolean> {
    return this._authState$;
  }
  
  // Sign in with email/password
  public async signIn(email: string, password: string): Promise<void> {
  const user: any = await this.getUserInfoByEmail(email);
  
  const brand: any = await this.getBrandInfo(user.brandId);

  if (user?.partnerVerified !== undefined && user?.partnerVerified === true) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then(async (result) => {
        this.setUserData({... user, ... brand});
        this.router.navigate(['dashboard']);
      })
      .catch((error) => {
        let msg = 'Algo salió mal, intenta refrescar la página e intenta de nuevo';
        if (error.code === 'auth/wrong-password') {
          this.error = 'Contraseña inválida.';
        }
        if (error.code === 'auth/invalid-email') {
          this.error = 'Correo inválido';
        }
      });
  } else {
    // User is not partner verified or the property is missing, show an error message
    this._snackBar.open('Tu cuenta no está verificada como socio o falta la propiedad.', 'Ok', {
      duration: 3000
    });
  }
}

async getUserInfoByEmail(email: string) {
  try {
    const userQuerySnapshot = await this.afs.collection('users', ref => ref.where('email', '==', email)).get().toPromise();
    
    if (!userQuerySnapshot.empty) {
      // Get the first document found (assuming email is unique)
      const userDoc = userQuerySnapshot.docs[0];
      return userDoc.data();
    } else {
      // Handle the case where the user with the specified email is not found
      throw new Error('User not found');
    }
  } catch (error) {
    this.error = 'No existe una cuenta con este correo';
    throw error;
  }
}

public async getBrandInfo(brandId: string): Promise<User> {
  try {
    const brandDoc = await this.afs.collection('brands').doc(brandId).get().toPromise();

    if (brandDoc.exists) {
      const brandData = brandDoc.data() as any;
      return brandData;
    } else {
      // Handle the case where the brand with the specified brandId is not found
      throw new Error('Brand not found');
    }
  } catch (error) {
    this.error = 'Este correo no esta registrado como partner';
    throw error;
  }
}

public async isInstagramAccountExist(instagram: string): Promise<any> {
  try {
    // const brandDoc = await this.afs.collection('brands').doc(instagram).get().toPromise();

    const brandDoc = await this.afs.collection('brands', ref => ref.where('name', '==', instagram)).get().toPromise();
    
    if (!brandDoc.empty) {
      // Get the first document found (assuming email is unique)
      const brand = brandDoc.docs[0];
      return brand.data();
    } else {
      return null
    }

  } catch (error) {
    console.error('Error fetching brand information:', error);
    throw error;
  }
}

  // Sign up with email/password
  public  signUp(email: string, password: string, instagram: string,
     priceRange: string, photoURL: string): Promise<boolean> {
       this.loading = true;
    return new Promise( (resolve, reject) =>{
      this.afAuth.createUserWithEmailAndPassword(email, password)
        .then(async (result) => {
          /* Call the SendVerificaitonMail() function when new user sign 
          up and returns promise */
          // Create a brand in the "brands" collection
          const brandId = this.afs.createId();

          const brandData: any = await this.isInstagramAccountExist(instagram); 

          if (brandData === null) {
            this.createAccount(instagram, false, priceRange, photoURL, brandId, result.user.uid).then(async (res)=>{
               await this.createUserRecord(result.user, instagram, brandId);
               resolve(true);
               this.signOut();
               this.loading = false;
            }).catch((error) => {
              reject(error);
              this._snackBar.open('Algo salió mal, intenta refrescar la página e intenta de nuevo', 'Ok', {
                duration: 3000
              });
              this.loading = false;
            })
          } else {
            await this.createUserRecord(result.user, instagram, brandData.id);
            this.signOut();
            resolve(true);
            this.loading = false;
          }

          // Create a user record in the "users" collection with partnerVerified set to false
        }).catch((error) => {
          reject(error);
          this._snackBar.open('Algo salió mal, intenta refrescar la página e intenta de nuevo', 'Ok', {
            duration: 3000
          });
          this.loading = false;
        })
    })
  }

  private async createUserRecord(user: any, account: string, brandId: string): Promise<void> {
    try {
      // Set the user data with partnerVerified set to false
      await this.afs.collection('users').doc(user.uid).set({
        displayName: account,
        brandId: brandId,
        email: user.email,
        userId: user.uid,
        partnerVerified: false,
        notificationsPerMonth: 3
        // Add any other user-related properties if needed
      });
    } catch (error) {
      console.error(error);
      // Handle errors here
    }
  }

  getCurrentUser() {
    return this.afAuth.authState;
  }

    /* Creaion of the event.
   * @param event 
   * @returns 
   */
    public async createAccount(account: string, partner: boolean, priceRange: string, photoURL: string, brandId: string, userId: string): Promise<any> {
      try {
        const options: any = {
          method: 'GET',
          url: 'https://instagram28.p.rapidapi.com/user_info',
          params: {
            user_name: account
          },
          headers: {
            'X-RapidAPI-Key': this.rapidKey,
            'X-RapidAPI-Host': 'instagram28.p.rapidapi.com'
          }
        };
    
        const response = await axios.request(options);
        const blobImage = this.dataService.dataURItoBlob(photoURL)
        const savedImg = await this.downloadAndSaveImage(blobImage, account);
  
        const searchTags = this.extractSubstrings(account);

        return this.afs.doc(`brands/${brandId}`).set({
          name: account,
          image: savedImg,
          brandResponsible: userId,
          instagramId: response?.data?.data?.user?.id,
          partner: true,
          priceRange,
          searchTags,
          id: brandId
        });
      } catch (error) {
        console.error(error);
        this._snackBar.open('Algo salió mal', 'Intenta de nuevo', {
          duration: 3000
        });
        return null;
      }
    }

    async downloadAndSaveImage(imageBlob: Blob, fileName: string): Promise<string> {
      try {
        const storageRef = this.storage.ref(`events/${fileName}`);
        const uploadTaskSnapshot = await storageRef.put(imageBlob);
    
        const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();
        console.log('Image saved to Firebase Storage:', downloadURL);
        return downloadURL;
      } catch (error) {
        throw error;
      }
    }
      
    private extractSubstrings(inputString: string): string[] {
      const substrings: string[] = [];
    
      for (let i = 0; i < inputString.length; i++) {
        for (let j = i + 1; j <= inputString.length; j++) {
          const substring = inputString.substring(i, j);
          substrings.push(substring);
        }
      }
    
      return substrings;
    }
  // Send email verfificaiton when new user sign up
  public sendVerificationMail(){
    return this.afAuth.currentUser.then(u => {
      if (u) {
        u.sendEmailVerification()
        .then(() => {
          this.router.navigate(['verify-email-address']);
        })
      }
    })
  }

  // Reset Forggot password
  public forgotPassword(passwordResetEmail: string) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
    .then(() => {
      this._snackBar.open('Contraseña reseteada, chequea to bandeja de correo.', 'Ok', {
        duration: 3000
      });
    }).catch((error) => {
      this._snackBar.open('Algo salió mal, intenta refrescar la página e intenta de nuevo', 'Ok', {
        duration: 3000
      });
    })
  }

  // Returns true when user is looged in and email is verified
  public async isLoggedIn(): Promise<boolean> {
    return new Promise((resolve, reject ) => {
      let user = JSON.parse(localStorage.getItem('user') || '{}');
      this.dataService.getUserInfo(user?.uid || user?.userId).then((res)=>{
        this.userData = {...res, ...user};
        resolve((Object.keys(user).length !== 0) ? true : false)
      }).catch((e)=>{
        resolve(false);
      })
    })
  }

  // // Sign in with Google
  public googleAuth() {
    return this.authLogin(new auth.GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  public authLogin(provider: any) {
    return this.afAuth.signInWithPopup(provider)
    .then((result) => {
      this.setUserData(result.user);
      this.router.navigate(['dashboard']);
    }).catch((error) => {
      this._snackBar.open('Algo salió mal, intenta refrescar la página e intenta de nuevo', 'Ok', {
        duration: 3000
      });
    })
  }

  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  public setUserData(user: any) {
    this.userData = user;
    localStorage.setItem('user', JSON.stringify(this.userData));
  }

  // Sign out 
  public signOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['sign-in']);
    })
  }

}